import { FontAwesome5 } from '@expo/vector-icons';
import { secondaryFontFamily, styled } from '@openeducation/oe-it-themes';
import React, { memo } from 'react';
import type { StyleProp, TextStyle, ViewStyle } from 'react-native';

import { OEText } from '../oe-text/oe-text';

export interface TooltipBalloonProps {
  containerStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  triangleStyle?: StyleProp<ViewStyle>;
  color?: string;
  text: string;
}

const TooltipBalloon = ({
  text = '',
  color,
  containerStyle,
  textStyle,
  triangleStyle,
}: TooltipBalloonProps) => {
  return (
    <Container color={color} style={[containerStyle]}>
      <PercentText style={textStyle}>{text}</PercentText>
      <TriangleDownIcon color={color} style={triangleStyle} />
    </Container>
  );
};

type ColorProp = {
  color?: string;
};

const Container = styled.View<ColorProp>`
  background-color: ${({ theme, color }) =>
    color ? color : theme.color.primary};
  padding: 3px 6px;
  border-radius: 5px;
  min-width: 52px;
  position: relative;
`;

const PercentText = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.white,
  fontFamily: secondaryFontFamily,
  fontType: 'normal',
  fontSize: 14,
  textAlign: 'center',
}))``;

const TriangleDownIcon = styled(FontAwesome5).attrs<ColorProp>(
  ({ theme, color }) => ({
    color: color ? color : theme.color.primary,
    name: 'sort-down',
    size: 20,
  })
)`
  position: absolute;
  bottom: -8px;
  align-self: center;
`;

export default memo(TooltipBalloon);
